
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24.43 28.684"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-19.625 1)"}},[_c('circle',{staticClass:"a",attrs:{"cx":"6.188","cy":"6.188","r":"6.188","transform":"translate(25.652)"}}),_c('path',{staticClass:"a",attrs:{"d":"M31.84 15.469a11.215 11.215 0 00-11.215 11.215h22.43A11.215 11.215 0 0031.84 15.469z"}})])])
          )
        }
      }
    